/**
 * AW Quick Add
 * Multi-variant: pill click → immediate AJAX add-to-cart (no submit button).
 * Single-variant: submit button → AJAX add-to-cart.
 */

class AwQuickAddController {
  constructor(el) {
    this.el = el;
    this.pills = el.querySelectorAll('.aw-quick-add__variant-pill');
    this.submit = el.querySelector('.aw-quick-add__submit');

    this.bindEvents();
  }

  bindEvents() {
    // Multi-variant: each pill is its own add-to-cart trigger
    this.pills.forEach((pill) => {
      pill.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (pill.disabled) return;
        this.addToCart(pill.dataset.variantId, pill);
      });
    });

    // Single-variant: dedicated submit button
    if (this.submit) {
      this.submit.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.addToCart(this.submit.dataset.variantId, this.submit);
      });
    }
  }

  addToCart(variantId, triggerEl) {
    if (!variantId) return;

    const cartNotification = document.querySelector('cart-notification');

    triggerEl.disabled = true;
    triggerEl.classList.add('is-loading');

    const body = JSON.stringify({
      id: Number(variantId),
      quantity: 1,
      sections: cartNotification.getSectionsToRender().map((s) => s.id),
      sections_url: window.location.pathname,
    });

    fetch(window.routes.cart_add_url, { ...fetchConfig('javascript'), body })
      .then((r) => {
        if (!r.ok) throw new Error(r.statusText);
        return r.json();
      })
      .then((parsedState) => {
        triggerEl.classList.remove('is-loading');
        triggerEl.classList.add('is-success');
        cartNotification.renderContents(parsedState);
        setTimeout(() => {
          triggerEl.classList.remove('is-success');
          triggerEl.disabled = false;
        }, 1200);
      })
      .catch((err) => {
        console.error('[AwQuickAdd] Add to cart error:', err);
        triggerEl.classList.remove('is-loading');
        triggerEl.disabled = false;
      });
  }
}

function initAwQuickAdd(root = document) {
  root.querySelectorAll('[data-aw-quick-add]').forEach((el) => {
    if (!el.dataset.awQuickAddInit) {
      el.dataset.awQuickAddInit = '1';
      new AwQuickAddController(el);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => initAwQuickAdd());
document.addEventListener('shopify:section:load', (e) => initAwQuickAdd(e.target));